import { render, staticRenderFns } from "./Ticket-Visit-Reminder.vue?vue&type=template&id=2acaffe6"
import script from "./Ticket-Visit-Reminder.vue?vue&type=script&lang=js"
export * from "./Ticket-Visit-Reminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports